
<div *ngIf="!this.error">
  <h2>Saving confirmation to the database...</h2>
</div>
<p *ngIf="this.error">
  {{this.error}}
</p>
